import { Injectable } from '@angular/core';
import { IProvider } from '../iprovider';
import { BaseService } from './base.service';

@Injectable()
export class BaseRichService extends BaseService implements IProvider {

  perform(entity: string, action: string, row: any, options?: any) {
    return this.apiCall(`api/${entity}/${action.toLowerCase()}`, row, undefined, options);
  }

}
